import 'reflect-metadata';
import { injectable } from 'inversify';
import folders from 'mocks/organizer/folders.json';
import tasks from 'mocks/organizer/tasks.json';
import taskDetails from 'mocks/organizer/taskDetails.json';
import deleteTask from 'mocks/organizer/deleteTask.json';

@injectable()
class OrganizerMockService {
  constructor() {
    this.folders = folders;
    this.tasks = tasks;
    this.taskDetails = taskDetails;
    this.postTaskResponse = deleteTask;
  }

  async getFoldersList(params, abortSignal) {
    // eslint-disable-next-line no-console
    console.log(
      `in api getFoldersList params = ${JSON.stringify(
        params,
      )}, abortSignal = ${!!abortSignal}`,
    );
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.folders.data.items);
      }, 300);
    });
  }

  async getTasksList(params, abortSignal) {
    // eslint-disable-next-line no-console
    console.log(
      `in api getTasksList params = ${JSON.stringify(
        params,
      )}, abortSignal = ${JSON.stringify(abortSignal)}`,
    );
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.tasks.data.items);
      }, 300);
    });
  }

  async getTaskDetails(id) {
    // eslint-disable-next-line no-console
    console.log(`in getTaskDetails, id = ${id}`);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.taskDetails.data);
      }, 300);
    });
  }

  async deleteTask(id) {
    // eslint-disable-next-line no-console
    console.log(`in deleteTask, id = ${id}`);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.postTaskResponse.data);
      }, 300);
    });
  }

  async completeTask(id, resultTask) {
    // eslint-disable-next-line no-console
    console.log(`in completeTask, id = ${id}, result = ${resultTask}`);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.postTaskResponse.data);
      }, 300);
    });
  }

  async closeTask(id) {
    // eslint-disable-next-line no-console
    console.log(`in closeTask, id = ${id}`);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.postTaskResponse.data);
      }, 300);
    });
  }

  async reopenTask(id) {
    // eslint-disable-next-line no-console
    console.log(`in reopenTask, id = ${id}`);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.postTaskResponse.data);
      }, 300);
    });
  }

  async addTask(formData) {
    // eslint-disable-next-line no-console
    console.log(`in addTask, formData = ${JSON.stringify(formData)}`);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.taskDetails.data);
      }, 300);
    });
  }

  async updateTask(taskId, formData) {
    // eslint-disable-next-line no-console
    console.log(
      `in updateTask, taskId = ${taskId}, formData = ${JSON.stringify(
        formData,
      )}`,
    );
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.taskDetails.data);
      }, 300);
    });
  }

  async getFolder(folderId) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const foldersApi = this.folders.data.items;
        const foundFolder = foldersApi.filter(
          (folder) => folder.id.toString() === folderId.toString(),
        );
        const response = {
          apiVersion: '1',
          context: '',
          id: '',
          method: 'Folders/<int:pk>->GET',
          data: {
            items: foundFolder,
          },
        };

        resolve(response.data.items);
      }, 300);
    });
  }
}

export default OrganizerMockService;
